// Conta do usuário logado. US-C12: troca de senha (inclusive a provisória).
import AXIOS from "@/services/axios";

export class Account {
  static changePassword({ currentPassword, password, passwordConfirmation }) {
    return AXIOS.patch("account/password", {
      current_password: currentPassword,
      password,
      password_confirmation: passwordConfirmation
    });
  }
}

export default Account;
